"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iProjectSearchResponse = exports.iProjectSearchResponseMinimal = exports.iProjectConfiguration = exports.iCustomerConfiguration = exports.iConfigurationResponseError = exports.iConfigurationResponse = exports.iConfigurationRequest = exports.iAuthenticationResponseError = exports.iAuthenticationResponse = exports.iAuthenticationRequest = void 0;
const t = require("io-ts");
exports.iAuthenticationRequest = t.interface({
    grant_type: t.string,
    username: t.string,
    password: t.string
});
exports.iAuthenticationResponse = t.interface({
    access_token: t.string,
    token_type: t.string,
    expires_in: t.number,
    userName: t.string,
    issued: t.string,
    expires: t.string
});
exports.iAuthenticationResponseError = t.interface({
    error: t.string,
    error_description: t.string
});
// Configuration content
exports.iConfigurationRequest = t.interface({
    grant_type: t.string,
    username: t.string,
    password: t.string
});
exports.iConfigurationResponse = t.interface({
    access_token: t.string,
    token_type: t.string,
    expires_in: t.number,
    userName: t.string,
    issued: t.string,
    expires: t.string
});
exports.iConfigurationResponseError = t.interface({
    Message: t.string,
    ModelState: t.string
});
exports.iCustomerConfiguration = t.interface({
    customerId: t.number,
    configurationId: t.number
});
exports.iProjectConfiguration = t.interface({
    configurationId: t.number,
    projectId: t.number,
    modelspaceProjectId: t.string
});
exports.iProjectSearchResponseMinimal = t.interface({
    name: t.string,
    number: t.string,
});
exports.iProjectSearchResponse = t.array(t.intersection([
    exports.iProjectSearchResponseMinimal,
    t.interface({
        name: t.union([t.string, t.null, t.undefined]),
        number: t.union([t.string, t.null, t.undefined]),
        startDate: t.union([t.string, t.null, t.undefined]),
        endDate: t.union([t.string, t.null, t.undefined]),
        status: t.union([t.string, t.null, t.undefined]),
        manager: t.union([t.string, t.null, t.undefined]),
        address: t.union([t.string, t.null, t.undefined]),
        zip: t.union([t.string, t.null, t.undefined]),
        city: t.union([t.string, t.null, t.undefined])
    })
]));
//# sourceMappingURL=modelspace.js.map